import { useEffect, useState } from "react"

export function useStateDeps<T>(value: T, deps?: any[]): [T, (value: T) => void] {
  const [state, setState] = useState<T>(value)
  useEffect(() => setState(value), deps ?? [value])
  return [state, setState]
}
